import _extends from "@babel/runtime-corejs3/helpers/extends";
import _flatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import { createUnknownComponentVNode as _$cc, className as _$cn, createVNode as _$cv, createElementVNode as _$ce, noop as _$no, map as _$ma, extend as _$ex, EMPTY_OBJ as _$em } from 'intact-vue';
import { TransitionGroup, Transition } from 'intact-vue';
import { Input } from '../input';
import { Icon } from '../icon';
import { isNullOrUndefined, isStringOrNumber } from 'intact-shared';
import { makeStyles } from './styles';
import { Dropdown } from '../dropdown';
import { getRestProps, addStyle } from '../utils';
import { Wave } from '../wave';
import { context as ErrorContext } from '../form/useError';
import { Tags, Tag } from '../tag';
var _$tmp0 = {
  'className': 'ion-load-c',
  'rotate': true
};
export default function ($props, $blocks, $__proto__) {
  var _classNameObj,
    _this = this;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    value = _this$get.value,
    multiple = _this$get.multiple,
    loading = _this$get.loading,
    disabled = _this$get.disabled,
    name = _this$get.name,
    size = _this$get.size,
    hideIcon = _this$get.hideIcon,
    fluid = _this$get.fluid,
    clearable = _this$get.clearable,
    filterable = _this$get.filterable,
    className = _this$get.className,
    container = _this$get.container,
    inline = _this$get.inline,
    style = _this$get.style,
    width = _this$get.width,
    show = _this$get.show,
    position = _this$get.position,
    flat = _flatInstanceProperty(_this$get),
    nowrap = _this$get.nowrap,
    draggable = _this$get.draggable;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-select"] = true, _classNameObj[k + "-disabled"] = disabled, _classNameObj[k + "-" + size] = size !== 'default', _classNameObj[k + "-fluid"] = fluid, _classNameObj[k + "-inline"] = inline, _classNameObj[k + "-flat"] = flat, _classNameObj[k + "-nowrap"] = nowrap, _classNameObj[className] = className, _classNameObj[$props.className] = $props.className, _classNameObj[makeStyles(k)] = true, _classNameObj);
  var placeholder = this.getPlaceholder();
  var label = this.getLabel();
  var hasValue = this.hasValue();
  var _this$input = this.input,
    onInput = _this$input.onInput,
    inputRef = _this$input.inputRef,
    keywords = _this$input.keywords.value;
  var _this$focusout = this.focusout,
    onFocusout = _this$focusout.onFocusout,
    triggerRef = _this$focusout.triggerRef;
  var filterInput = filterable ? _$cc(Input, {
    'className': _$cn(k + "-select-input"),
    'value': keywords,
    'ev-$change:value': onInput,
    'disabled': disabled,
    'placeholder': !hasValue ? placeholder : '',
    'ref': inputRef,
    'autoWidth': true,
    'inline': true,
    'size': size,
    'key': 'filter',
    'readonly': !show,
    'waveDisabled': true,
    'flat': flat
  }, 'filter', inputRef) : undefined;
  return _$cc(ErrorContext.Consumer, {
    'defaultValue': false,
    'children': function children(isInvalid) {
      var _$cn2;
      return _$cc(Wave, {
        'disabled': disabled || isInvalid || inline,
        'inset': '-2px',
        'children': _$cc(Dropdown, {
          'trigger': 'click',
          'ref': _this.dropdownRef,
          'disabled': disabled,
          'container': container,
          'position': position,
          'children': [_$cv('div', _extends({}, getRestProps(_this), {
            'className': _$cn(classNameObj),
            'tabindex': disabled ? '-1' : '0',
            'ev-keydown': _this.onKeydown,
            'ev-focusout': onFocusout,
            'style': !isNullOrUndefined(width) ? addStyle(style, {
              width: width + "px"
            }) : style,
            'ref': triggerRef
          }), [$blocks.prefix ? _$ce(2, 'div', (_$blocks['prefix'] = function ($super) {
            return null;
          }, __$blocks['prefix'] = function ($super, data) {
            var block = $blocks['prefix'];
            var callBlock = function callBlock() {
              return _$blocks['prefix'].call($this, $super, data);
            };
            return block ? block.call($this, callBlock, data) : callBlock();
          }, __$blocks['prefix'](_$no)), 0, _$cn(k + "-select-prefix")) : undefined, _$ce(2, 'div', [_$ce(64, 'input', null, 1, null, {
            'type': 'hidden',
            'value': value,
            'name': name
          }, 'hidden-input'), null, _$cc(TransitionGroup, {
            'name': 'k-fade',
            'appear': false,
            'children': !multiple && filterable ? _$cc(Input, {
              'value': show ? keywords : label,
              'ev-$change:value': onInput,
              'disabled': disabled,
              'placeholder': label || placeholder,
              'ref': inputRef,
              'size': size,
              'fluid': true,
              'inline': true,
              'key': 'input',
              'readonly': !show,
              'waveDisabled': true,
              'flat': flat
            }, 'input', inputRef) : !filterable && !hasValue ? _$ce(2, 'div', placeholder, 0, _$cn(k + "-select-placeholder c-ellipsis"), null, 'placeholder') : !multiple ? _$ce(2, 'div', (_$blocks['value'] = function ($super) {
              return label;
            }, __$blocks['value'] = function ($super, data) {
              var block = $blocks['value'];
              var callBlock = function callBlock() {
                return _$blocks['value'].call($this, $super, data);
              };
              return block ? block.call($this, callBlock, data) : callBlock();
            }, __$blocks['value'](_$no, [value, label])), 0, _$cn(k + "-select-value c-ellipsis"), null, 'value') : _$ce(2, 'div', [(_$blocks['values'] = function ($super) {
              return label && label.length || filterable ? _$cc(Tags, {
                'nowrap': nowrap,
                'size': size,
                'draggable': draggable,
                'ev-dragend': this.draggable,
                'children': _$ma(label, function ($label, $key) {
                  return _$cc(Tag, {
                    'key': isStringOrNumber($label) ? $label : isStringOrNumber(value[$key]) ? value[$key] : $key,
                    'closable': true,
                    'ev-close': this.delete.bind(this, $key),
                    'disabled': disabled,
                    'size': size,
                    'children': (_$blocks['value'] = function ($super) {
                      return $label;
                    }, __$blocks['value'] = function ($super, data) {
                      var block = $blocks['value'];
                      var callBlock = function callBlock() {
                        return _$blocks['value'].call($this, $super, data);
                      };
                      return block ? block.call($this, callBlock, data) : callBlock();
                    }, __$blocks['value'](_$no, [value[$key], $label]))
                  }, isStringOrNumber($label) ? $label : isStringOrNumber(value[$key]) ? value[$key] : $key);
                }, $this),
                '$blocks': function ($blocks) {
                  var _$blocks = {},
                    __$blocks = _$ex({}, $blocks);
                  return (_$blocks['append'] = function ($super) {
                    return filterInput;
                  }, __$blocks['append'] = function ($super, data) {
                    var block = $blocks['append'];
                    var callBlock = function callBlock() {
                      return _$blocks['append'].call($this, $super, data);
                    };
                    return block ? block.call($this, callBlock, data) : callBlock();
                  }), __$blocks;
                }.call($this, _$em)
              }) : undefined;
            }, __$blocks['values'] = function ($super, data) {
              var block = _valuesInstanceProperty($blocks);
              var callBlock = function callBlock() {
                return _valuesInstanceProperty(_$blocks).call($this, $super, data);
              };
              return block ? block.call($this, callBlock, data) : callBlock();
            }, _valuesInstanceProperty(__$blocks).call(__$blocks, _$no, [value, label])), $blocks && _valuesInstanceProperty($blocks) ? filterInput : undefined], 0, _$cn(k + "-select-values"), null, 'values')
          })], 0, _$cn(k + "-select-main")), !hideIcon || clearable || loading || $blocks.suffix ? _$ce(2, 'span', [clearable && !disabled ? _$cc(Icon, {
            'className': _$cn((_$cn2 = {}, _$cn2[k + "-select-clear ion-ios-close"] = true, _$cn2[k + "-show"] = hasValue, _$cn2)),
            'ev-click': _this.clear,
            'hoverable': true
          }) : undefined, _$ce(2, 'span', (_$blocks['suffix'] = function ($super) {
            return loading ? _$cc(Icon, _$tmp0) : !hideIcon ? filterable && show ? _$cc(Icon, {
              'className': _$cn(k + "-icon-search")
            }) : _$cc(Icon, {
              'className': _$cn(k + "-select-arrow " + k + "-icon-down"),
              'disabled': $props.isDisableArrow
            }) : undefined;
          }, __$blocks['suffix'] = function ($super, data) {
            var block = $blocks['suffix'];
            var callBlock = function callBlock() {
              return _$blocks['suffix'].call($this, $super, data);
            };
            return block ? block.call($this, callBlock, data) : callBlock();
          }, __$blocks['suffix'](_$no)), 0, _$cn(k + "-select-suffix-icon"))], 0, _$cn(k + "-select-suffix")) : undefined]), (_$blocks['base-menu'] = function ($super) {
            return _$ce(2, 'div', 'should be implemeted', 16);
          }, __$blocks['base-menu'] = function ($super, data) {
            var block = $blocks['base-menu'];
            var callBlock = function callBlock() {
              return _$blocks['base-menu'].call($this, $super, data);
            };
            return block ? block.call($this, callBlock, data) : callBlock();
          }, __$blocks['base-menu'](_$no))],
          'ev-$model:value': function ev$modelValue($v) {
            $this.set('show', $v);
          },
          'value': $this.get('show')
        }, null, _this.dropdownRef)
      });
    }
  });
}
;